import { Outlet } from 'react-router-dom';
import { Suspense } from 'react';
import { Navigation } from './Navigation';

// Minimal content skeleton for route loading
const ContentSkeleton = () => (
  <div className="max-w-7xl mx-auto px-4 py-8">
    <div className="animate-pulse space-y-6">
      <div className="h-8 bg-muted rounded w-1/3"></div>
      <div className="h-4 bg-muted rounded w-1/2"></div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="h-32 bg-muted rounded"></div>
        ))}
      </div>
    </div>
  </div>
);

export const Layout = () => {
  return (
    <div className="min-h-screen bg-gradient-subtle">
      <Navigation />
      <main className="pt-20 sm:pt-28 md:pt-36">
        <Suspense fallback={<ContentSkeleton />}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
};